import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
   {
      path: '/',
      name: 'Login',
      component: () => import('../views/Login.vue')
   },
   {
      path: '/paginaInicial',
      name: 'Página_inicial',
      component: () => import('../views/PaginaInicial.vue')
   },
   {
      path: '/usuarios',
      name: 'Usuários',
      component: () => import('../views/pages/Usuarios.vue')
   },
   {
      path: '/sentenciados/:cpf?',
      name: 'Sentenciados',
      component: () => import('../views/pages/Sentenciados.vue')
   },
   {
      path: '/entidades',
      name: 'Entidades',
      component: () => import('../views/pages/Entidades.vue')
   },
   // {
   //    path: '/processos',
   //    name: 'Processos',
   //    component: () => import('../views/pages/Processos.vue')
   // },
   {
      path: '/sentencas',
      name: 'Sentencas',
      component: () => import('../views/pages/Sentencas.vue')
   },
   // {
   //    path: '/alertas',
   //    name: 'Alertas',
   //    component: () => import('../views/pages/Alertas.vue')
   // },
   {
      path: '/arquivos',
      name: 'Arquivos',
      component: () => import('../views/pages/Arquivos.vue')
   },
   // {
   //    path: '/newpage',
   //    name: 'newpage',
   //    component: () => import('../views/pages/NewPage.vue')
   // }
]

const router = new VueRouter({
   mode: 'abstract',
   base: process.env.BASE_URL,
   routes
})

export default router
